import { createAPIService } from './api.service';
import { defaultAPIError } from './errors';

const service = createAPIService('/unstructured/api/v1/data');

export const post = async body => (await service.post('', body)).data;

service.patch = async args => {
  try {
    return await post(args);
  } catch (err) {
    throw defaultAPIError(err);
  }
};

export default service;
